import React, { Component } from 'react';
import { DataReservation } from '../../data/DataReservation';
import { EUIComboBox } from '../EUI/EUIComboBox';

export class ComboBoxReservation extends Component {

    static defaultProps = {
        idOperation: 0,
        inclureVentesEnBloc: false,
        label: "Réservation",
        masquerSiDroitsInsuffisants: true,
        placeholder: "Réservation",
    };

    render = () => {

        const { idOperation, inclureVentesEnBloc, masquerSiDroitsInsuffisants } = this.props;

        let fetchMethod;
        if (!!idOperation)
            fetchMethod = () => DataReservation._chargementListeDesReservations(idOperation, inclureVentesEnBloc);

        let itemHidden = null;
        if (masquerSiDroitsInsuffisants) {
            itemHidden = item => {
                const droits = item.droits.split(';#');
                const peutReserver = droits[3] === "1";
                const peutAccederReservation = droits[2] === "1";
                return peutReserver || !peutAccederReservation;
            };
        }

        return <EUIComboBox
            {...this.props}
            fetchMethod={fetchMethod}
            itemHidden={itemHidden}
            itemKey={item => item.idReservation}
            itemText={item => item.numero}
            stamp={[idOperation, inclureVentesEnBloc, masquerSiDroitsInsuffisants]}
        />;

    };

};